import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class ProgramMainView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    // downloads
    const downloads = [...container.querySelectorAll(".program-downloads ul li")]
    if (downloads.length) {
      TweenMax.set(downloads, {y: 0})
      TweenMax.from(downloads, .5, {y: -60, delay: (i) => .3 + i*.07, ease: Power3.easeOut})
    }
    const days = [...container.querySelectorAll(".day-main")]
    days.forEach((el, index) => {
      const del = index * .2;
      const title = el.querySelector(".day-title .inner")
      const events = [...el.querySelectorAll(".event-list")]
      const t = new TimelineMax({repeat: 0})
      t.set(el, {opacity: 1, y: 0})
      t.set(title, {opacity: 1, y: 0})
      t.set(events, {opacity: 1, y: 0})
      t.from(el, .05, {opacity: 0, delay: del})
      t.from(el, .4, {y: -200, delay: del, ease: Power4.easeOut}, 0)
      t.from(title, .4, {y: -60, opacity: 0, ease: Power4.easeOut}, .3)
      t.from(events, .4, {y: 30, opacity: 0, delay: (i) => i * .1, ease: Power4.easeOut}, .3)
    })
    // compliance
    const footer = container.querySelector(".program-main-footer")
    if (footer) {
      TweenMax.set(footer, {opacity: 1})
      TweenMax.from(footer, .5, {opacity: 0, delay: .6})
    }
    
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    // compliance
    const footer = container.querySelector(".program-main-footer")
    if (footer) {
      TweenMax.to(footer, .25, {opacity: 0})
    }
    const days = [...container.querySelectorAll(".day-main")]
    days.forEach((el, index) => {
      const del = index * .05;
      const title = el.querySelector(".day-title .inner")
      const events = [...el.querySelectorAll(".event-list")]
      const t = new TimelineMax({repeat: 0})
      t.to(events, .2, {y: 30, opacity: 0, delay: (i) => i * .05, ease: Power4.easeIn})
      t.to(title, .25, {y: -60, opacity: 0, ease: Power4.easeIn}, .2)
      t.to(el, .3, {y: -200, delay: del, ease: Power4.easeIn}, .3)
      t.to(el, .05, {opacity: 0, delay: del}, .55)
    })
    // downloads
    const downloads = [...container.querySelectorAll(".program-downloads ul li")]
    if (downloads.length) {
      TweenMax.to(downloads, .4, {y: -60, delay: (i) => .2 - i*.07, ease: Power3.easeIn})
    }
  }

}

export default ProgramMainView